<script setup lang="ts">
import { useCheckoutFlow } from '@/composables/useCheckoutFlow';

const props = defineProps<{
  currentStep: any;
  isStepValid: boolean;
  onStepComplete: () => void;
}>();

const { isStepLoading } = useCheckoutFlow();
</script>

<template>
  <div class="sticky-next-step-container d-flex flex-column px-4">
    <v-row>
      <v-col>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn
          block
          append-icon="mdi-arrow-right"
          color="primary"
          :disabled="!props.isStepValid"
          :loading="isStepLoading"
          @click="onStepComplete()">
          Next
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.sticky-next-step-container {
  position: sticky;
  bottom: 0;
  background: white;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
</style>
